export default __webpack_public_path__ + "static/media/OnlineBackground.cc98fccb.svg";